/**
 * C 端用户路由守卫
 * 未登录或 token 已过期时重定向到 /login
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import userAuthService from '../../services/userAuthService';

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (_) {
    return true;
  }
}

function RequireUserAuth({ children }) {
  const location = useLocation();
  if (process.env.REACT_APP_DISABLE_USER_AUTH === 'true') {
    return children;
  }
  const token = userAuthService.getAccessToken();
  if (!token || isTokenExpired(token)) {
    // token 不存在或已过期，清除旧数据后跳登录
    if (token) userAuthService.clear();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export default RequireUserAuth;
